// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1346":"b0425aea","2883":"62383016","4039":"91486953","5527":"a2447d4b","8381":"62383016","8734":"eddfca1e"}[chunkId] + ".chunk.css";
};